<template>
  <v-container id="user-profile-view" fluid tag="section">
    <template>
      <v-card>
        <v-card-title>
          Karyawan
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="employees"
          :search="search"
        >
          <template v-slot:item.actions="{ item }">
            <v-icon class="mr-2" @click="openEditDialog(item)">
              mdi-pencil
            </v-icon>
            <div class="d-md-none my-5"></div>
            <v-icon @click="openDeleteDialog(item)"> mdi-delete </v-icon>
          </template>
        </v-data-table>
      </v-card>
    </template>

    <v-btn
      @click="openCreateModal = true"
      color="primary"
      dark
      fixed
      bottom
      right
      fab
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <!-- Create Modal -->
    <CreateModal
      :openModal="openCreateModal"
      @close-modal="
        openCreateModal = false;
        fetchEmployee();
      "
    />

    <!-- Create Modal -->
    <EditModal
      :openModal="openEditModal"
      :id="id"
      @close-modal="
        openEditModal = false;
        id = '';
        fetchEmployee();
      "
    />
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "DataKaryawanView",
  components: {
    CreateModal: () => import("@/components/DataKaryawan/CreateModal.vue"),
    EditModal: () => import("@/components/DataKaryawan/EditModal.vue")
  },
  data() {
    return {
      openCreateModal: false,
      openEditModal: false,
      id: "",
      search: "",
      headers: [
        {
          text: "No",
          align: "start",
          value: "user_id"
        },
        { text: "Nama", value: "nama" },
        { text: "Status", value: "status" },
        { text: "Alamat", value: "alamat" },
        { text: "Telp", value: "telp" },
        { text: "Ket", value: "ket" },
        {
          text: "Aktif",
          align: "center",
          value: "is_active"
        },
        { text: "Actions", value: "actions", sortable: false }
      ],
      loading: false,
      employees: []
    };
  },
  methods: {
    async fetchEmployee() {
      this.loading = true;

      await axios
        .get(`karyawan`)
        .then(res => {
          this.loading = false;
          this.employees = res.data;
        })
        .catch(err => {
          // console.log(err.response.data);
        });
    },
    openEditDialog(item) {
      this.id = item.user_id;
      this.openEditModal = true;
    },
    async openDeleteDialog(item) {
      if (!confirm("Apakah anda yakin ingin menghapus data ini?")) return;

      this.loading = true;

      await axios
        .delete(`karyawan/${item.user_id}`)
        .then(res => {
          this.loading = false;

          this.fetchEmployee();
        })
        .catch(err => {
          // console.log(err.response.data);
        });
    }
  },
  created() {
    this.fetchEmployee();
  }
};
</script>
